var StyleTypes;
(function (StyleTypes) {
    StyleTypes["GREY"] = "grey";
    StyleTypes["OFFWHITE"] = "off-white";
    StyleTypes["BURGUNDY"] = "burgundy";
    StyleTypes["PURPLE"] = "purple";
})(StyleTypes || (StyleTypes = {}));

export { StyleTypes };
